// import external dependencies
import 'jquery';
import 'isotope-layout/dist/isotope.pkgd.min.js';
import 'bootstrap/dist/js/bootstrap';
import 'bootstrap-select/dist/js/bootstrap-select.min.js';
import 'slick-carousel/slick/slick.min.js';
import 'moment';
import 'fullcalendar';
// import 'masonry-layout';
import 'jquery-match-height';
// import 'desandro-matches-selector/matches-selector.js';

// Import everything from autoload
import "./autoload/_bootstrap.js"

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/aboutUs';
import careers from './routes/careers';
import singlePost from './routes/singlePost';
import professionalPortalLogin from './routes/professionalPortalLogin';
import singleProduct from './routes/singleProduct';
import postTypeArchiveProduct from './routes/postTypeArchiveProduct';
import pressCenter from './routes/pressCenter';
import magazine from './routes/magazine';
import epionceNearYou from './routes/epionceNearYou';
import signup from './routes/signup';
import shoppingBag from './routes/shoppingBag';
import checkout from './routes/checkout';
import woocommerceOrderReceived from './routes/woocommerceOrderReceived';
import myAccount from './routes/myAccount';
import schedule from './routes/schedule';
import pageRegisterData from './routes/pageRegisterData';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common, // All pages
  home,
  aboutUs, // About Us page, note the change from about-us to aboutUs.
  careers,
  singlePost,
  professionalPortalLogin,
  singleProduct,
  postTypeArchiveProduct,
  pressCenter,
  magazine,
  epionceNearYou,
  signup,
  shoppingBag,
  checkout,
  woocommerceOrderReceived,
  myAccount,
  schedule,
  pageRegisterData,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());


// WEBPACK FOOTER //
// ./scripts/main.js